import { gsap } from 'gsap';

import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Draggable } from 'gsap/Draggable';
import { CustomEase } from 'gsap/CustomEase';
import { aboutUsAnimation } from './animations/about-us-hero';
import { shapesAnimation } from './animations/shapes-hero';
import { educationArchiveAnimation } from './animations/education-archive';
import { educationInnerAnimation } from './animations/education-inner';
import { admissionHeroAnimation } from './animations/admission-hero';
import { campsHeroAnimation } from './animations/camps-hero';
import { teamHeroAnimation } from './animations/team-hero';
import { careersAnimation } from './animations/career-cards';
import { careersHeroAnimation } from './animations/careers-hero';
import { productArchiveHeroAnimation } from './animations/product-archive';
import {
	heroContentAnimation,
	heroImageAnimation,
	parallaxBg,
} from './animations/common';

gsap.registerPlugin(ScrollTrigger, Draggable, CustomEase);

export const initAnimations = () => {
	heroContentAnimation();
	heroImageAnimation();
	educationArchiveAnimation();
	educationInnerAnimation();
	admissionHeroAnimation();
	campsHeroAnimation();
	teamHeroAnimation();
	careersAnimation();
	aboutUsAnimation();
	shapesAnimation();
	careersHeroAnimation();
	parallaxBg();
	productArchiveHeroAnimation();
};
